<template>
  <button class="button">
    <slot></slot>
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.button {
  border: 1px solid $lightGray;
  background: #fff;
  border-radius: 8px;
  padding: 10px 11px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 6px;
  transition: 200ms;

  &:hover,
  &:focus,
  &.active {
    outline: none;
    border: 1px solid $primaryColor;
  }
}
</style>
